export const DIGITAL_HEALTH_COMITEES_WITH_ACTE_REMUNERATION_PREFIX = '330';
export const DIGITAL_HEALTH_COMITEES_WITH_MIXTE_REMUNERATION_PREFIX = '331';

export const DIGITAL_HEALTH_COMITEES_LUMPSUM_CODE = 'xxx420';

export const isDigitalHealthComiteeCode = (code) => code === DIGITAL_HEALTH_COMITEES_LUMPSUM_CODE;
